export default __webpack_public_path__ + "img/df37150cdfffedbd63335c2c0706357f.png";